import { getAvailableChannels, getAvailableVariants } from './get-demo-previews';

/**
 * Filtra las opciones de los selects según el estado actual del formulario.
 * Solo muestra opciones válidas para evitar combinaciones imposibles.
 */
export const getDynamicOptions = (fieldKey: string, formData: any, baseOptions: any[]): any[] | undefined => {
  if (fieldKey === 'adChannel') {
    const currentStage = formData.stage;
    const currentVariant = formData.variant;

    if (!currentStage) {
      return baseOptions;
    }

    // Si no hay variant seleccionado, mostrar todos los canales del stage
    if (!currentVariant) {
      const availableChannels = getAvailableChannels(currentStage);
      return baseOptions.filter(option => availableChannels.includes(option.value));
    }

    // Si hay variant, solo mostrar canales que tengan ese variant
    const availableChannels = getAvailableChannels(currentStage).filter(channel => {
      const variants = getAvailableVariants(currentStage, channel);
      return variants.includes(currentVariant);
    });

    return baseOptions.filter(option => availableChannels.includes(option.value));
  }
  if (fieldKey === 'variant') {
    const currentStage = formData.stage;
    const currentChannel = formData.adChannel;

    if (!currentStage || !currentChannel) {
      return baseOptions; // Sin stage o channel, mostrar todas
    }

    const availableVariants = getAvailableVariants(currentStage, currentChannel);

    // Filtrar solo las variantes disponibles para este stage + channel
    return baseOptions.filter(option => availableVariants.includes(option.value));
  }

  // Para otros campos, usar las opciones base
  return undefined;
};
